import {SLOT_MANAGEMENT_ERROR_CODES} from '../consts'
import {AvailableSlotsResponse, ProcessedSlotResponse} from '../requests'

/**
 * Helper to process API response from backend availability endpoint.
 * Transforms raw API response into a processed state with derived flags.
 *
 * @param response - Response from GET /rmcSlots/available
 * @returns Processed state with flags derived from error codes
 */
export const processAvailabilityResponse = (
  response: AvailableSlotsResponse
): ProcessedSlotResponse => {
  const {errorCode, availableSlots} = response

  return {
    availableSlots: availableSlots || [],
    isOutOfAutoConfirmLeadTime: errorCode === SLOT_MANAGEMENT_ERROR_CODES.INSUFFICIENT_LEAD_TIME
  }
}
